<div mat-dialog-content>
  <div class="dialog-header">
    @if (data.isDestructive) {
      <mat-icon class="warning-icon">warning</mat-icon>
    }
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>
  <p>{{ data.message }}</p>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">
    {{ data.cancelText || 'Cancel' }}
  </button>
  <button 
    mat-flat-button 
    [class.destructive]="data.isDestructive"
    (click)="onConfirm()">
    {{ data.confirmText || 'Confirm' }}
  </button>
</div>
